  <div class="outer-wrapper">
  <h2 mat-dialog-title class="web-dialog-title">{{heading}}</h2>
  <div class="top-wrapper">
    <div class="model-name" [title]="textureSyncData.modelName">{{textureSyncData.modelName}}</div>
    <div class="model-divider"></div>
  </div>


    <div class="collection-input-wrapper">
      <div class="textures-section">
        <div class="textures-header">
          <span class="textures-count">{{headerText}} <span class="missing-count"> {{missingTexturesCount}}/{{totalTextures}}</span></span>
        </div>
        <div class="textures-list" #texturesList 
          (scroll)="onTexturesScroll()"
          [class.scrollable]="isTexturesScrollable">
          <div class="texture-item"
               *ngFor="let texture of textureSyncData.missingTextures"
               [class.uploaded]="texture.uploaded"
               [class.uploading]="texture.isUploading"
               [class.clickable]="!texture.uploaded && !texture.isUploading"
               (click)="onTextureItemClick(texture)"
               >

            <mat-spinner *ngIf="texture.isUploading" class="upload-spinner" diameter="16" strokeWidth="2" mode="determinate" [value]="texture.uploadProgress || 0"></mat-spinner>

            <svg *ngIf="texture.uploaded && !texture.isUploading" class="check-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <span class="texture-name" [title]="getTextureTooltip(texture)">{{texture.name}}</span>
          </div>
        </div>
      </div>
    </div>

<mat-dialog-actions align="center">
  <button class="back-btn" (click)="onBackClick()">
    <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="web-btn-text">Back</span>
  </button>

  <button class="create-btn" (click)="onMainBtnClick()" [disabled]="!(showRetryButton || showSelectTexturesButton)">
    <ng-container *ngIf="showRetryButton || showSelectTexturesButton">
      <span>{{mainButtonText}}</span>
    </ng-container>
    <ng-container *ngIf="!showRetryButton && !showSelectTexturesButton">
      &nbsp;
      <span>
        <div class="circle-progress-bar-wrapper button-progress">
          <div class="pie spinner"></div>
          <div class="pie backcolor"></div>
        </div>
      </span>
    </ng-container>
  </button>

  <button class="cancel-btn" (click)="onAbortClick()">
    <div class="img-wrapper">
      <img src="assets/images/icons/close-icon-black.svg" alt="Close" class="cancel-icon">
    </div>
    <span class="web-btn-text">Abort</span>
  </button>
</mat-dialog-actions>
</div>

<app-fullsize-dragdrop
  [modeLocal]="true"
  [class.activezone]="isDragOverDialog"

  [isFolderSelectEnabled]="false"
  [labelText]="'Drop files here'"
  [outputToParent]="true"
  (filesDropped)="onFilesDropped($event)">
</app-fullsize-dragdrop>
